export const GET_COVERAGE = 'coverage/GET_COVERAGE';